import { render } from "./panel-header.vue?vue&type=template&id=6293ee4b&scoped=true"
import script from "./panel-header.vue?vue&type=script&lang=ts"
export * from "./panel-header.vue?vue&type=script&lang=ts"

import "./panel-header.vue?vue&type=style&index=0&id=6293ee4b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6293ee4b"

export default script